import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/EnpointCards.css';
import labService from './labService';
import authService from '../auth/authService';
import HashLoader from "react-spinners/HashLoader";
import { getApiErrorMessage } from '../auth/apiError';

const LOAD_ERROR = 'Endpoints could not be loaded. Please refresh the page.';

const EndpointCards = () => {
  const [endpoints, setEndpoints] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [endpsLoading, setEndpsLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const user = authService.getCurrentUser();
    setCurrentUser(user);
  }, []);

  useEffect(() => {
    if (currentUser) {
      labService.getEndpoints()
        .then(response => {
          setEndpoints(response.data)
          setEndpsLoading(false)
        })
        .catch(error => {
          // Only a network failure says more than the fixed sentence; server texts aren't for users.
          setLoadError(error.response ? LOAD_ERROR : getApiErrorMessage(error, LOAD_ERROR));
          setEndpsLoading(false);
        });
    }
  }, [currentUser]);

  const handleNewPredictionClick = (endpoint, hasModels) => {
    if (hasModels) {
    localStorage.setItem('selectedEndpoint', JSON.stringify(endpoint.id));
    navigate(`/choose-model/${endpoint.id}`);
    }
  };

  return (
    <div className="home-content">
      <h2 className='aval-endp'>Available endpoints</h2>
      {endpsLoading ? (
        <div className='loader-div'>
          <HashLoader className='loader' size={120} color='#0b5578' />
        </div>
      ) : loadError ? (
        <p className='lab-error' role='alert'>{loadError}</p>
      ) : (
        <div className='cards-container'>
          {endpoints.map((endpoint) => {
            const hasModels = endpoint.ml_models && endpoint.ml_models.length > 0;
            const imgUrl = hasModels ? endpoint.img_url : endpoint.img_non_act_url;
            const cardClass = hasModels ? 'card active' : 'card non-active-card';
            return (
              <div className='card-wrapper' key={endpoint.id}>
                <div className={cardClass} onClick={() => handleNewPredictionClick(endpoint, hasModels)}>
                  {!hasModels && <div className="coming-soon-banner">AVAILABLE SOON!</div>}
                  <h2>{endpoint.endpoint_name}</h2>
                  <img src={imgUrl} alt={endpoint.endpoint_name} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default EndpointCards;
